import { View } from 'react-native'
import Typography from '@ui/typography'
import { colors } from '@ui/colors'
import Icon from '@ui/elements/Icon'

interface Props {
  text: string
  color?: string
}

export default function HelpText({ text, color = colors.neutral[400] }: Props) {
  return (
    <View className="flex flex-row items-start justify-start gap-2 pt-3">
      <View
        className="flex w-4 items-center justify-center"
        style={{ paddingTop: 1 }}
      >
        <Icon name="info-circle" color={color} size={16} />
      </View>
      <Typography variant="XS" color={color}>
        {text}
      </Typography>
    </View>
  )
}
